import React from 'react';
import T from 'prop-types';

import PageModal from '../../../Modals/PageModal';
import UpsertCustomExportForm from '../../UpsertCustomExportForm';

const AdvancedChangesModal = ({
  open,
  initParams = {},
  formMode,
  formActions,
  prefetchingEntities,
  onInitialLoad,
  onDataTypeChange,
  onClose,
}) => (
  <PageModal
    open={open}
    shouldCloseOnOverlayClick={false}
    className="global-upsert-export-modal"
    header={<div className="global-upsert-export-modal__title">Export Data</div>}
    main={(
      <div className="global-upsert-export-modal__body">
        <UpsertCustomExportForm
          initParams={initParams}
          formMode={formMode}
          dataType="base"
          formActions={formActions}
          prefetchingEntities={prefetchingEntities}
          onInitialLoad={onInitialLoad}
          onDataTypeChange={onDataTypeChange}
          onClose={onClose}
        />
      </div>
    )}
    onClose={onClose}
  />
);

AdvancedChangesModal.propTypes = {
  open: T.bool.isRequired,
  initParams: T.object,
  formMode: T.object,
  formActions: T.object,
  prefetchingEntities: T.bool,
  onInitialLoad: T.func,
  onDataTypeChange: T.func,
  onClose: T.func,
};

export default AdvancedChangesModal;
